import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  LinearProgress,
  Slide,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import { IoCloseOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import Utils from "../utils";
import { updatePayroll } from "../services/payroll.service";
import Constants from "../data/Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PayrollDialog(props) {
  const { hooks, forceUpdateView, setToast } = props;

  const [selectedPayroll, setSelectedPayroll] = hooks;

  const [inputs, setInputs] = useState({
    amount: {
      error: false,
      helperText: undefined,
    },
    confirmAmount: {
      error: false,
      helperText: undefined,
    },
  });

  const navigate = useNavigate();

  const [status, setStatus] = useState({
    loading: false,
    error: false,
    success: false,
  });

  useEffect(() => {
    setToast(status);
  }, [status]);

  const handleClose = () => {
    setSelectedPayroll(false);
  };

  const handleStatusChange = async (id, status, amount, reason = "") => {
    try {
      if (status == "PROCESSING" && !amount) {
        return setInputs({
          ...inputs,
          amount: {
            error: true,
            helperText: "Amount is required",
          },
        });
      }

      setStatus({
        loading: true,
        error: false,
      });

      const data = await updatePayroll(id, {
        status: status.toUpperCase(),
        amount: amount,
        statusMessage: reason,
      });

      setStatus({
        loading: false,
        error: false,
        success: true,
        message: "Updated Successfully",
      });

      handleClose();
      forceUpdateView(1); // notify parent to rerender changes
    } catch (error) {
      // error
      setStatus({
        loading: false,
        error: true,
        message: Utils.CustomErrorMessage(error),
      });
    }
  };
  return selectedPayroll ? (
    <Dialog
      open={selectedPayroll ? true : false}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>
            <h2 className="font-extrabold text-lg">Payroll Payment Status</h2>
          </Box>
          <Box>
            <IconButton onClick={handleClose}>
              <IoCloseOutline />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <div className="">
          {selectedPayroll.status == "PROCESSING" ? (
            <div className="flex flex-col gap-5">
              <div>
                Are you sure you want to approve the payroll transaction?
              </div>
              <TextField
                label="Amount in Rupees"
                variant="filled"
                size="small"
                className="col-span-2"
                fullWidth
                name="amount"
                error={inputs.amount.error}
                helperText={inputs.amount.helperText}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {Constants.CURRENCY_SYMBOL}
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  if (
                    !/^\d+$/.test(e.target.value) ||
                    e.target.value < 1 ||
                    e.target.value > Constants.Safety.TRANSACTION_UPPER_LIMIT
                  ) {
                    console.log(e.target.value);
                    setInputs({
                      ...inputs,
                      amount: {
                        error: true,
                        helperText:
                          "Amount should be a valid number between 0 and " +
                          Constants.Safety.TRANSACTION_UPPER_LIMIT,
                      },
                    });
                  } else {
                    setInputs({
                      ...inputs,
                      amount: {
                        error: false,
                        helperText: undefined,
                      },
                    });
                    setSelectedPayroll({
                      ...selectedPayroll,
                      unconfirmedAmount: e.target.value,
                    });
                  }
                }}
              />
              <TextField
                label="Confirm Amount in Rupees"
                variant="filled"
                size="small"
                className="col-span-2"
                fullWidth
                error={inputs.confirmAmount.error}
                helperText={inputs.confirmAmount.helperText}
                name="amount"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {Constants.CURRENCY_SYMBOL}
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  if (e.target.value != selectedPayroll.unconfirmedAmount) {
                    console.log(e.target.value);
                    setInputs({
                      ...inputs,
                      confirmAmount: {
                        error: true,
                        helperText: "Amount are Confirm Amount are not equal",
                      },
                    });
                  } else {
                    setInputs({
                      ...inputs,
                      confirmAmount: {
                        error: false,
                        helperText: undefined,
                      },
                    });
                    setSelectedPayroll({
                      ...selectedPayroll,
                      amount: e.target.value,
                    });
                  }
                }}
              />
            </div>
          ) : (
            <div className="flex flex-col gap-5">
              Please provide a reason for cancelling the payroll transaction
              <TextField
                label="Rejection Message"
                placeholder="Reason for Cancellation"
                variant="filled"
                size="small"
                className="col-span-2"
                multiline
                fullWidth
                minRows={3}
                onChange={(e) => {
                  setSelectedPayroll({
                    ...selectedPayroll,
                    failedReason: e.target.value,
                  });
                }}
              />
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Back</Button>

        {selectedPayroll.status == "PROCESSING" ? (
          <Button
            color="success"
            onClick={() => {
              handleStatusChange(
                selectedPayroll.id,
                selectedPayroll.status,
                selectedPayroll.amount
              );
            }}
          >
            Approve
          </Button>
        ) : (
          <Button
            color="error"
            onClick={() => {
              handleStatusChange(
                selectedPayroll.id,
                selectedPayroll.status,
                undefined,
                selectedPayroll.failedReason
              );
            }}
          >
            Decline
          </Button>
        )}
      </DialogActions>
      {status.loading ? (
        <Box>
          <LinearProgress />
        </Box>
      ) : (
        ""
      )}
    </Dialog>
  ) : (
    ""
  );
}

export default PayrollDialog;
